// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"a860488c","146":"fef9cbc2","371":"81cb5014","511":"e0ca1c73","549":"e4ab88df","587":"73a453c0","979":"53b40049"}[chunkId] + ".chunk.css";
};